import { ApiSubClient } from './ApiSubClient';

export class AuthClient extends ApiSubClient {
  adminCreateUser = (email: string, adminPassword: string) => {
    return this.core.post('/admin/create_user', { email, adminPassword }, this.core.SERVICES.api);
  };

  createRoomInvite = (roomRoute: string, ttlMinutes?: number) => {
    return this.core.post<{ code: string; url: string; expiresAt: string }>(
      '/create_room_invite',
      { roomRoute, ttlMinutes },
      this.core.SERVICES.api
    );
  };
}
